import {
  Box,
  CardContent,
  Icon,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { appIcons, appImages } from "../../assets";
import GlobalButton from "../button";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShinyChip from "../shinyChip";
import { useNavigate } from "react-router-dom";
import AddToCartButton from "../cartButton";
import { CURRENCY } from "../../lib/variables";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useSelector } from "react-redux";

const AddToCartBtnStyle = {
  backgroundColor: "text.white",
  borderColor: "text.white",
  boxShadow: "none",
  borderRadius: 0,
  height: 50,
  width: "70%",
  alignSelf: "center",
  color: "#6F6F6F",
};
const outOfStockBtnStyle = {
  backgroundColor: "text.white",
  borderColor: "text.white",
  boxShadow: "none",
  borderRadius: 0,
  height: 50,
  width: "70%",
  alignSelf: "center",
  color: "text.orangeRed",
};

const heartBtnStyle = {
  position: "absolute",
  top: 15,
  right: 0,
  border: `1px solid grey`,
};

const RelatedProductCard = ({ data }) => {
  const navigate = useNavigate();
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const isDiscount = data.discount > 0 ? true : false;
  const productPrice = data.discount > 0 ? data.discount : data.price;

  let isSizes = data?.size?.length === 0;
  let isColors = data?.color?.length === 0;
  let isSizesWithColors = data?.sizeWithColor?.length === 0;
  let isWeight = data?.weigth.length === 0;

  let isOutOfStock = false;
  let isVariation = false;

  if (
    !isSizes ||
    !isColors ||
    !isSizesWithColors ||
    !isWeight ||
    data.type === "Package"
  ) {
    isVariation = true;
  }

  if (isSizes && isColors && isSizesWithColors && data?.quantity === 0) {
    isOutOfStock = true;
  }

  if (!isSizes) {
    isOutOfStock = data?.size?.every((itemmmm) => itemmmm.quantity === 0);
  }

  if (!isWeight) {
    isOutOfStock = data?.weigth?.every((itemmmm) => itemmmm.quantity === 0);
  }

  if (!isColors) {
    isOutOfStock = data?.color?.every((itemmmm) => itemmmm.quantity === 0);
  }

  if (!isSizesWithColors) {
    outerLoop: for (
      let index = 0;
      index < data.sizeWithColor?.length;
      index++
    ) {
      for (
        let jindex = 0;
        jindex < data.sizeWithColor[index].colors?.length;
        jindex++
      ) {
        if (data.sizeWithColor[index].colors[jindex].quantity > 0) {
          isOutOfStock = false;
          break outerLoop;
        } else {
          isOutOfStock = true;
        }
      }
    }
  }

  const renderButtonQuantityBased = () => {
    if (isVariation) {
      return (
        <GlobalButton
          variant={"outlined"}
          startIcon={<img src={appIcons.addCartBtnIcon} width={18} />}
          btnText={"View Detail"}
          handleClickBtn={(e) => {
            e.stopPropagation();
            navigate(`/product/${data.productUrl}`);
          }}
          styleProps={{
            ...AddToCartBtnStyle,
          }}
        />
      );
    } else {
      return <AddToCartButton product={data} isPurple={false} />;
    }
  };

  return (
    <Box
      onClick={() => {
        navigate(`/product/${data.productUrl}`);
      }}
      sx={{
        cursor: "pointer",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        bgcolor={"text.lightGrey"}
        gap={2}
        px={2}
        pt={2}
        pb={2}
        position={"relative"}
      >
        {data?.type === "Package" && <ShinyChip />}
        <Stack position={"relative"}>
          {/* <IconButton
            sx={{
              ...heartBtnStyle,
            }}
          >
            <FavoriteIcon htmlColor="red" />
          </IconButton> */}
        </Stack>
        <Box
          height={"200px"}
          width={"100%"}
          borderRadius={2}
          overflow={"hidden"}
          bgcolor="text.lightGrey"
          position={"relative"}
        >
          <Carousel
            showArrows
            infiniteLoop
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            renderArrowPrev={(clickHandler, hasPrev) => {
              return (
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    padding: "3px",
                    position: "absolute",
                    top: "40%",
                    left: "5px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: 2,
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(e);
                  }}
                >
                  <KeyboardArrowLeft sx={{ fontSize: "20px" }} />
                </IconButton>
              );
            }}
            renderArrowNext={(clickHandler, hasNext) => {
              return (
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    padding: "3px",
                    position: "absolute",
                    top: "40%",
                    right: "5px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: 2,
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(e);
                  }}
                >
                  <KeyboardArrowRight sx={{ fontSize: "20px" }} />
                </IconButton>
              );
            }}
          >
            {data?.images?.map((imageee) => {
              return (
                <img
                  src={imageee}
                  style={{
                    height: "200px",
                    aspectRatio: 16 / 9,
                    width: "100%",
                    objectFit: "cover",
                    loading: "lazy",
                  }}
                />
              );
            })}
          </Carousel>
        </Box>

        {renderButtonQuantityBased(isOutOfStock)}
      </Box>
      <CardContent>
        <Typography
          variant="body1"
          fontWeight={500}
          textAlign={"center"}
          noWrap
        >
          {data?.name[currentLanguage]}
        </Typography>

        {data.type !== "Food" && data.weigth?.length === 0 && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            my={0.5}
          >
            <Typography fontSize="1.125rem" fontWeight={600}>
              {`${CURRENCY} ${productPrice}`}
            </Typography>
            {isDiscount && (
              <Typography
                fontSize="1rem"
                color="text.coolGrey"
                sx={{ textDecoration: "line-through" }}
              >
                {`${CURRENCY} ${data.price}`}
              </Typography>
            )}
          </Stack>
        )}

        {data.type === "Food" && data.weigth?.length > 0 && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            my={0.5}
          >
            <Typography fontSize="1.125rem" fontWeight={600}>
              {` ${CURRENCY} ${data.weigth[0].price} | ${data.weigth[0].name[currentLanguage]}`}
            </Typography>
          </Stack>
        )}
      </CardContent>
    </Box>
  );
};

export default RelatedProductCard;
